var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50037 3.10656L1.5 11.125C1.5 12.7819 2.78942 14.1375 4.41953 14.2434L4.625 14.25L10.143 14.2509C9.88535 14.9787 9.19106 15.5 8.375 15.5H4C1.92893 15.5 0.25 13.8211 0.25 11.75V4.875C0.25 4.05848 0.771929 3.36386 1.50037 3.10656ZM10.875 0.5C11.9105 0.5 12.75 1.33947 12.75 2.375V11.125C12.75 12.1605 11.9105 13 10.875 13H4.625C3.58947 13 2.75 12.1605 2.75 11.125V2.375C2.75 1.33947 3.58947 0.5 4.625 0.5H10.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.4a465dca1b77727cf9f8ddd214f45ad8.svg";
export { ForwardRef as ReactComponent };